export const blockedFileTypes = [
  'ac',
  'action',
  'ade',
  'adp',
  'apk',
  'app',
  'application',
  'aru',
  'as',
  'asp',
  'aspx',
  'asx',
  'awk',
  'bas',
  'bat',
  'bin',
  'btm',
  'cer',
  'chm',
  'class',
  'cmd',
  'cnt',
  'com',
  'command',
  'cpl',
  'crt',
  'csh',
  'der',
  'diagcab',
  'dll',
  'docm',
  'dotm',
  'drv',
  'ear',
  'exe',
  'fxp',
  'gadget',
  'grp',
  'gzquar',
  'hlp',
  'hpj',
  'hta',
  'htc',
  'iim',
  'inf',
  'ins',
  'inx',
  'ipa',
  'isp',
  'isu',
  'its',
  'jar',
  'jnlp',
  'job',
  'js',
  'jse',
  'jsx',
  'ksh',
  'lnk',
  'lo',
  'ls',
  'lua',
  'mad',
  'maf',
  'mag',
  'mam',
  'maq',
  'mar',
  'mas',
  'mat',
  'mau',
  'mav',
  'maw',
  'mcf',
  'mda',
  'mdb',
  'mde',
  'mdt',
  'mdw',
  'mdz',
  'msc',
  'msh',
  'msh1',
  'msh1xml',
  'msh2',
  'msh2xml',
  'mshxml',
  'msi',
  'msp',
  'mst',
  'msu',
  'mxe',
  'nexe',
  'obs',
  'ocx',
  'ops',
  'osd',
  'osx',
  'otm',
  'out',
  'ozd',
  'paf',
  'pcd',
  'pf',
  'pif',
  'plg',
  'plx',
  'potm',
  'ppam',
  'ppsm',
  'pptm',
  'prf',
  'prg',
  'printerexport',
  'ps1',
  'ps1xml',
  'ps2',
  'ps2xml',
  'psc1',
  'psc2',
  'psd1',
  'psd2',
  'psdm1',
  'pst',
  'pvd',
  'py',
  'pyc',
  'pyo',
  'pyz',
  'pyzw',
  'rb',
  'reg',
  'rgs',
  'run',
  'sca',
  'scb',
  'scf',
  'scr',
  'script',
  'sct',
  'shb',
  'shs',
  'sldm',
  'theme',
  'tlb',
  'tmp',
  'u3p',
  'udf',
  'url',
  'vb',
  'vbe',
  'vbp',
  'vbs',
  'vbscript',
  'vhd',
  'vhdx',
  'vsmacros',
  'vsw',
  'webpnp',
  'website',
  'wiz',
  'wmf',
  'workflow',
  'wpk',
  'wpm',
  'ws',
  'wsc',
  'wsf',
  'wsh',
  'xap',
  'xbap',
  'xlam',
  'xll',
  'xlm',
  'xlsm',
  'xltm',
  'xnk',
  'zix',
];

export const getExtension = (filename) => {
  const i = filename.lastIndexOf('.');
  return i >= 0 ? filename.slice(i + 1).toLowerCase() : '';
};

export const isBlockedFile = (file) => {
  const blocked = new Set(blockedFileTypes.map((v) => v.toLowerCase()));
  return (
    blocked.has(file.type.toLowerCase()) || blocked.has(getExtension(file.name))
  );
};
